import { Routes } from '@angular/router';

export const v2DisplayCardsRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./v2-display-cards.page').then((m) => m.V2DisplayCardsPage),
  },
];
